export default __webpack_public_path__ + "static/media/sub-img.7bc646a3.png";